import { Component, effect, OnInit, signal } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { NgIf } from '@angular/common';
import { AuthService, helper, LoadingComponent, ToastComponent } from 'shared';
import { Collapse } from 'flowbite';
import { Helpers } from 'shared-lib';
import { iOS } from '../helper';
import { Browser } from '@capacitor/browser';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    NgIf,
    ToastComponent,
    RouterLink,
    RouterLinkActive,
    LoadingComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'app';
  isAuthenticated = signal<boolean>(false);
  collapse?: Collapse;
  ios = iOS()
  darkMode = false;

  constructor(private authService: AuthService) {
    this.authService.init();
    this.isAuthenticated = this.authService.isAuthenticated();
    effect(() => {
      if (this.authService.user()) {
        this.initNavbar(true);
      }
    });
    this.darkMode = helper.Functions.isDarkMode();
  }

  ngOnInit(): void {
    window
      .matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', () => {
        this.darkMode = helper.Functions.isDarkMode();
      });
  }

  async openCapacitorSite() {
    await Browser.open({ url: 'https://tialtonivel.com.br/' });
  };

  async initNavbar(force=false) {
    if (!this.collapse || force) {
      if(force){
        await Helpers.Functions.sleep(200)
      }
      const selector = 'tian-collapse-toggle';
      const element = document.querySelector(`[${selector}]`) as HTMLElement;
      const dropdownId = element?.getAttribute(selector);
      if (selector && dropdownId) {
        const dropdown = document.getElementById(dropdownId);
        this.collapse = new Collapse(dropdown, element);
      }
    }
  }

  collapseNavbar() {
    this.collapse?.collapse();
  }

  logout() {
    this.authService.logout();
  }
}
